import { BaseService } from './base.service';

export default class PaymentsService extends BaseService {
  public async createPaymentIntent(payload: any) {
    return this.axios.post(`${this.backendUrl}/create-payment-intent`, payload);
  }

  public async createSubscriptionSetup(payload: any) {
    return this.axios.post(`${this.backendUrl}/create-subscription`, payload);
  }

  public async getSubscriptionPrice() {
    return this.axios.get(`${this.backendUrl}/create-subscription`);
  }

  public async getPaymentStatus(paymentIntentSecret: any) {
    return this.axios.post(`${this.backendUrl}/confirm-payment`, { payment_intent_id: paymentIntentSecret });
  }

  public async initializePayment(subscriptionId: string, teamName: string, teamColor: string, teamDescription: string) {
    return this.axios.post(`${this.backendUrl}/initialize-payment`, {
      subscriptionId,
      teamName,
      teamColor,
      teamDescription,
    });
  }

  public async initializeUpgradePayment(subscriptionId: string, teamId: string) {
    return this.axios.post(`${this.backendUrl}/initialize-upgrade-payment`, { subscriptionId, teamId });
  }
}
